export enum PhoneNumberVerificationStage {
  CHANGE,
  NOT_VERIFIED,
  VERIFIED,
}
